import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
import app from './modules/app'
import session from './modules/session'
import account from './modules/account'
import user from './modules/user'
import role from './modules/role'
import tenant from './modules/tenant'
import page from './modules/page'
import post from './modules/post'
import podcasts from './modules/podcasts'
import category from './modules/categories'
import mediamanager from './modules/media-manager'
import medialist from './modules/media-list'
import mediapickerlist from './modules/media-picker-list'
import podcastlist from './modules/podcast-list'
import vfiles from './modules/vfiles'
import mediapicker from './modules/mediapicker'
import podcastpicker from './modules/podcastpicker'
import slider from './modules/slider'
import cards from './modules/cards'
import options from './modules/options'
import youtubevideos from './modules/youtubevideos'
import authors from './modules/authors'
import links from './modules/link'
import categorylist from './modules/category-list'
import gallery from './modules/gallery'
import newsletter from './modules/newsletter'
import books from './modules/books'
import features from './modules/features'
const store = new Vuex.Store({
    state: {
        //
    },
    mutations: {
        //
    },
    actions: {

    },
    modules: {
        app,
        session,
        account,
        user,
        role,
        tenant,
        page,
        post,
        mediamanager,
        medialist,
        mediapickerlist,
        mediapicker,
        category,
        vfiles,
        slider,
        cards,
        options,
        youtubevideos,
        authors,
        links,
        categorylist,
        podcasts,
        podcastlist,
        podcastpicker,
        gallery,
        newsletter,
        books,
        features
    }
});

export default store;